import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Setting } from 'src/app/models/setting';
import * as fromRoot from 'src/app/state/app.state';
import { SettingsActions, SettingsActionTypes } from './settings.actions';

export interface SettingsState {
  settings: Setting[];
  loaded: boolean;
  loading: boolean;
  error: string;

}

export interface State extends fromRoot.State {
  settings: SettingsState;
}

const initialSettingsState: SettingsState = {
  settings: [],
  loaded: false,
  loading: false,
  error: ''
};

const getSettingsFeatureState = createFeatureSelector<SettingsState>('settings');
export const getSettingsLoaded = createSelector(getSettingsFeatureState, state => state.loaded);
export const getSettingsLoading = createSelector(getSettingsFeatureState, state => state.loading);
export const getSettings = createSelector(getSettingsFeatureState, state => state.settings);
export const getError = createSelector(getSettingsFeatureState, state => state.error);
// export const getAreas = createSelector(getSettingsFeatureState, state => state['Bereiche'] || []);

export function reducer(state: SettingsState = initialSettingsState, action: SettingsActions): SettingsState {
  switch (action.type) {

    case SettingsActionTypes.Load:
      return {
        ...state,
        loading: true,
        error: ''
      };

    case SettingsActionTypes.LoadSuccess:
      // Defensive guard: if a malformed action somehow reaches the reducer,
      // coerce the payload to an empty array so consumers can never crash
      // on `settings.length` / `.filter(...)`.
      return {
        ...state,
        settings: Array.isArray(action.payload) ? action.payload : [],
        loaded: Array.isArray(action.payload),
        loading: false,
        error: Array.isArray(action.payload) ? '' : 'Settings payload was not an array.'
      };

    case SettingsActionTypes.LoadFail:
      return {
        ...state,
        settings: [],
        loaded: false,
        loading: false,
        error: action.payload
      };

    case SettingsActionTypes.Reset:
      return initialSettingsState;

    default:
      return state;
  }
}
